import React from 'react';

import { AppContextProvider } from '@contexts/AppContext';
import { SubscribeFormProvider } from '@contexts/SubscribeFormContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';
import { User } from '@utils/backend-api/currentUser';
import { OfferOption, SelectedOffer } from '@utils/backend-api/subscribe';
import { SubscriptionStatus } from '@utils/interfaces';

import Content from './Content';

interface DualSubscribeProps {
  billingAmountCBPT?: number;
  defaultSelectedOffer: SelectedOffer;
  description?: string;
  dob: string;
  initialCurrentUser?: User;
  isDueInFuture: boolean;
  isGdprRequired: boolean;
  isYPEligible: boolean;
  offers: OfferOption[];
  stripeCustomerId?: string;
  subscriptionStatus?: SubscriptionStatus;
  userDobVerified?: boolean;
  userEmail?: string;
  userFullName?: string;
  userId?: number;
  userNextBillingDate?: string;
}

const DualSubscribe = (props: DualSubscribeProps) => {
  const {
    isYPEligible,
    stripeCustomerId,
    subscriptionStatus,
    userDobVerified,
    userEmail,
    userFullName,
    userId,
  } = props;
  const { Track } = useEventTracking({
    page: Page.DualSubscribe,
  });

  return (
    <AppContextProvider
      initialCurrentUser={props.initialCurrentUser}
      isGdprRequired={props.isGdprRequired}
    >
      <SubscribeFormProvider
        user={{
          dobVerified: userDobVerified,
          email: userEmail,
          id: userId,
          isYPEligible,
          name: userFullName,
          stripeCustomerId,
          subscriptionStatus,
        }}
      >
        <Track>
          <Content {...props} />
        </Track>
      </SubscribeFormProvider>
    </AppContextProvider>
  );
};

export default DualSubscribe;
